import { useI18nContext } from "@hopper-b2b/i18n";
import {
  mapFtuVariantToCashbackCalculator,
  mapFtuVariantToCopy,
  useFtuExperiment,
} from "../../../utils/ftuExperiments";
import "./styles.scss";
import type { FiatPrice, IPerson } from "@hopper-b2b/types";

export const CashbackPriceSummary = ({
  price,
  passengers,
}: {
  price: FiatPrice;
  passengers: IPerson[];
}) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const { variant } = useFtuExperiment();
  const passSelector = passengers || [];
  const total = price;
  const paxCount = passSelector?.length || 1;

  const copyVariant = mapFtuVariantToCopy[variant];
  const getCashback = mapFtuVariantToCashbackCalculator[variant];
  const cashback = getCashback(total, paxCount);
  const cashbackString = formatFiatCurrency(getCashback(total, paxCount));

  if (!copyVariant || cashback.value === 0) return null;

  return (
    <div className="uber cash-back-ftu-discount description-text">
      <label>{t("ftu.cashbackWithAmount", { amount: cashbackString })}</label>
    </div>
  );
};
